import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skeletons/LobbyPageSkeleton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/lobby/components/FilterGames/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/lobby/components/GameCategorySlider/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/lobby/components/LayoutLobbyWithSlider/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/lobby/components/TournamentsSlider/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/lobby/providers/LobbyProvider.tsx");
